module.exports = __webpack_public_path__ + "img/3.a412cb31.png";